// @flow
import { UPDATE_USER, PERMISSIONS_USER } from '../../actions/user'
import type { 
  UPDATE_USER_TYPE, 
  PERMISSIONS_USER_TYPE 
} from '../../actions/user'
import { Auth } from '../../services/auth'

type State = {
  isLoggedIn: boolean,
  permissions: {
    admin: boolean,
    dev: boolean,
    beta: boolean,
    user: boolean
  },
  roles: ''
}

const initialState: State = {
  isLoggedIn: Auth.isAuthenticated(),
  permissions: {
    admin: false,
    dev: false,
    beta: false,
    user: false
  }
}

type Action = 
  | UPDATE_USER_TYPE
  | PERMISSIONS_USER_TYPE

export default function userReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case UPDATE_USER: {
      const { isLoggedIn } = action.payload
      return {
        ...state,
        isLoggedIn
      }
    }
    case PERMISSIONS_USER: {
      const { scope } = action.payload
      return {
        ...state,
        permissions: {
          admin: scope.includes('tools:admin'),
          dev: scope.includes('tools:dev'),
          beta: scope.includes('tools:beta'),
          user: scope.includes('tools:user'),
          freeUser: scope.includes('user:free'),
          eduUser: scope.includes('user:edu'),
          earningsUser: scope.includes('user:earnings'),
          coachingUser: scope.includes('user.coaching'),
          trialUser: scope.includes('user:trial'),
          portfolioTools: scope.includes('tools:portfolio'),
        },
        roles: scope
      }
    }
    default: {
      return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/user/index.js